// Sentences read aloud during the microphone check. Kept short (11-12 words),
// free of digits and proper nouns (Deepgram's smart_format/number-formatting
// is disabled for this flow, and proper nouns are easy to mis-hear), and
// phonetically varied so the check isn't trivially easy on any one accent.
export const MIC_CHECK_PHRASES = [
  "My microphone is working well and my voice sounds clear today.",
  "I am ready to begin and I hope my voice is heard clearly.",
  "Please check that my audio sounds sharp before the interview begins.",
];

// How long the candidate's level must stay below SPEAKING_LEVEL_THRESHOLD
// after they've started talking before we treat the sentence as finished
// and stop recording automatically.
export const SILENCE_STOP_MS = 2000;

// Hard cap on a single recording attempt, in case auto-stop-on-silence never
// triggers (e.g. constant background noise keeps the level up).
export const MAX_RECORD_MS = 15000;

// Deepgram keeps flushing trailing `is_final` results for a moment after
// CloseStream is sent. Wait this long before scoring so the last word or two
// of the phrase isn't unfairly counted as missing.
export const ANALYZE_GRACE_MS = 2500;

// Number of attempts a candidate can fail before a "Continue Anyway" escape
// hatch appears - protects against a real accent/mic mismatch locking
// someone out of their own interview.
export const MAX_ATTEMPTS_BEFORE_SKIP = 3;

// Mic level (0-1, average FFT byte magnitude) below which, if it was never
// exceeded during the whole attempt, we treat the mic as having picked up no
// sound at all - a distinct, more actionable message than "wrong words".
export const SILENCE_LEVEL_THRESHOLD = 0.04;

// Mic level above which the candidate is considered to be actively speaking,
// used to arm the auto-stop-on-silence timer above.
export const SPEAKING_LEVEL_THRESHOLD = 0.12;

/**
 * Pick a random phrase, optionally avoiding the one just read so "Use a
 * different sentence" always actually changes it.
 */
export function getRandomPhrase(excludePhrase) {
  const pool = excludePhrase
    ? MIC_CHECK_PHRASES.filter((phrase) => phrase !== excludePhrase)
    : MIC_CHECK_PHRASES;
  const list = pool.length ? pool : MIC_CHECK_PHRASES;
  return list[Math.floor(Math.random() * list.length)];
}
